import { Component, OnInit, Input, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { IFieldColumnOptions, GridColumnSortState } from '../../models';
import { IPopup } from 'ngx-fomantic-ui';
import { IFilter, ISimpleFilter } from '@poweredsoft/data';

@Component({
  selector: 'ps-field-data-grid-header-column',
  templateUrl: './field-data-grid-header-column.component.html',
  styleUrls: ['./field-data-grid-header-column.component.css']
})
export class FieldDataGridHeaderColumnComponent implements OnInit {

  @Input() column: IFieldColumnOptions;
  @Output() onSort: EventEmitter<IFieldColumnOptions> = new EventEmitter();
  @Input() sortState: GridColumnSortState;
  @Output() onFilter: EventEmitter<IFilter> = new EventEmitter();
  @Output() onClearFilter: EventEmitter<IFilter> = new EventEmitter();
  @Input() filter: IFilter = null;

  @ViewChild('filterValueControl', { static: false }) filterControl: ElementRef;

  hoverFilter: boolean = false;
  hoverSort: boolean = false;
  filterType: string = 'Contains';
  filterValue: string = null;
  
  constructor() { }

  ngOnInit() {
  }

  get sortable() {
    return this.column.sortable !== false;
  }

  get filterable() {
    return this.column.filterable !== false;
  }

  get sortableClasses() {
    return {
      icon: true,
      caret: true,
      down: this.sortState == GridColumnSortState.desc,
      up: this.sortState !== GridColumnSortState.desc,
      blue: this.hoverSort
    };
  }

  get filterableClasses() {
    return {
      icon: true,
      filter: true,
      red: this.filter ? true : false
    };
  }

  get sortOpacity() {
    return this.sortState !== GridColumnSortState.notSorted ? 1 : (this.hoverSort ? 0.8 : 0.2);
  }

  get filterOpacity() {
    return this.hoverFilter || this.filter ? 1 : 0.2;
  }

  sortIconClicked() {
    if (this.onSort)
      this.onSort.emit(this.column);
  }

  editFilter(popup: IPopup) {
    if (this.filter == null)
      this.filterValue = '';

    setTimeout(() => {
      popup.open();
      setTimeout(() => {
        this.filterControl.nativeElement.focus();
      });
    });
  }

  cancelFilter(popup: IPopup) {
    popup.close();
  }

  clearFilter(popup: IPopup) {
    this.filterValue = '';
    popup.close();
    this.onClearFilter.emit(this.filter);
  }

  applyFilter(popup: IPopup) {
    popup.close();
    this.onFilter.emit(<ISimpleFilter>{
      path: this.column.filterPath || this.column.field,
      value: this.filterValue,
      type: this.filterType,
      and: true
    });
  }
}
